import {styled, clsx, Fade} from 'external/material'
import useTranslations from 'hooks/translations'
import { centerVertically } from 'utils/style'
import DashboardMessage from './DashboardMessage'
import useStudent from 'hooks/student'
import useProfile from 'hooks/profile'

const StyledDashboardMessages = styled('div')(dashboardMessagesStyles)

export default function DashboardMessages(props) {
    
    const {locked, lockedMessage} = useProfile()
    const {messages, messagesSources, messagesSource: source, update} = useStudent()
    const {translate} = useTranslations()
    
    const {items, loading} = messages

    return(
        <StyledDashboardMessages {...props}>
            <div className='messages-header'>
                <div className='messages-sources'>
                    {messagesSources.map(sourceName => {
                        const active = locked ? (sourceName == 'news') : (source == sourceName)
                        return (
                        <div
                            key={sourceName}
                            onClick={() => update({messagesSource: {$set: sourceName}})}
                            className={clsx('messages-source', {active})}
                        >
                            {translate(sourceName)}
                        </div>
                    )})}
                </div>
            </div>
            <div className='messages-content'>
                <div className='messages-wrapper'>
                    <Fade in={!loading}>
                        <div className='messages-container'>
                            {(locked ? [{...lockedMessage}] : items).map((message, index) => (<DashboardMessage key={index} {...message} />))}
                        </div>
                    </Fade>
                </div>
            </div>
        </StyledDashboardMessages>
    )
}

function dashboardMessagesStyles(){
    return {
        display: 'flex',
        flexGrow: 1,
        minHeight: 200,
        flexDirection: 'column',
        overflowY: 'hidden',
        '& .messages-sources': {
            display: 'flex',
            marginTop: 15,
            marginRight: 75,
            justifyContent: 'flex-end',
            '& .messages-source': {
                ...centerVertically,
                textTransform: 'capitalize',
                cursor: 'pointer',
                color: '#a5a8ac',
                padding: '5px 30px',
                borderBottom: 'solid 5px transparent',
                '&:hover': {
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                    backgroundColor: '#ebdcdc4d',
                    borderBottom: 'solid 5px #ede0d2'
                },
                '&.active:hover': {
                    backgroundColor: 'transparent',
                },
                '&.active': {
                    cursor: 'default',
                    color: '#434a5d',
                    borderBottom: 'solid 5px #f3ab58'
                }
            }
        },
        '& .messages-content': {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            paddingBottom: 10,
            '& .messages-wrapper': {
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
                '& .messages-container': {
                    flexGrow: 1,
                    marginTop: -1,
                    display: 'flex',
                    flexDirection: 'column',
                    paddingRight: 5,
                    "& .content": {
                        flexShrink: 0
                    },
                    '& .dashboard-message': {
                        marginTop: 10,
                        "&:first-of-type": {
                            marginTop:0
                        },
                        flexShrink: 0,
                        padding: '25px 20px',
                        backgroundColor: '#fff',
                        marginRight: 10,
                        border: 'solid 1px #e5e7ee',
                        borderRadius: 18,
                    }
                }
            }
        },
    }
}